import { useEffect } from "react";
import type { FaceId } from "~/lib/faces";
import { useVisitor } from "~/lib/store";

export function useMarkFaceVisited(faceId: FaceId): void {
  const visit = useVisitor((s) => s.visit);
  useEffect(() => {
    visit(faceId);
  }, [faceId, visit]);
}
